import React from 'react';

import { reactAppApiUrl } from '../api';
import Image from './Image';
import SymbolIcon from './SymbolIcon';

const TokenImage = ({
  as,
  children,
  thumbnail: thumb = true,
  expandable = false,
  token = {},
  ...props
}) => {
  const {
    address,
    ercType,
    img,
    label = '',
    metadata: { image, preview, thumbnail },
    symbol,
    tokenId,
  } = token;

  let urls = [thumbnail, preview, image];
  urls = [
    ...(thumb ? urls : urls.reverse()),
    // fallback to symbol
    img,
    `/images/tokens/${symbol}.png`,
    `${reactAppApiUrl}/tokens/${address}/logo`,
    // default/final fallback
    '/ethereum.png',
  ];

  const expandedLabel = `${label}${tokenId ? ` '${tokenId}'` : ''}`;

  return (
    <Image
      as={as}
      srcs={urls}
      placeholder={() => <SymbolIcon symbol={symbol} address={address} />}
      expandedTitle={expandedLabel}
      expandedComponent={(src) => (
        <Image as={as} placeholderSrc={src} srcs={[image, preview, ...urls]} loadingSpinner />
      )}
      {...props}
      expandable={expandable && ercType !== 20}
    >
      {children}
    </Image>
  );
};

export default TokenImage;
